import React, { useState, useEffect } from "react";
import ChatWindow from "./ChatWindow";
import ChatMessageKit from "../../data/ChatMessageKit";
import ChatIndicator from "./ChatIndicator";
import ChatWindowView from "./ChatWindowView";
import { usePrivateChat } from "./hooks/usePrivateChat";

export default function PrivateChatWrapper({ me, urlParams }) {
  const MAX_INBOXES = 3;
  const { privateChatList, privateChatIndicatorList, unreadMessages } =
    usePrivateChat({ me, urlParams, maxOpenInboxes: MAX_INBOXES });

  return (
    <>
      {
        <div className="d-flex">
          {privateChatList &&
            Object.entries(privateChatList).map((inbox, i) => {
              const [inboxUUID, data] = inbox;

              return (
                <ChatWindow {...data.props}>
                  {(props) => <ChatWindowView {...props} />}
                </ChatWindow>
              );
            })}

          {privateChatIndicatorList && (
            <ChatIndicator
              unreadMessages={unreadMessages}
              userInboxList={privateChatIndicatorList}
            />
          )}
        </div>
      }
    </>
  );
}
